// extracted by mini-css-extract-plugin
export default {"empty":"ErrorBoundary_empty__KBV6c"};